import { Autocomplete, TextField } from '@mui/material';

export const SelectRadioQuestion = ({ index, question, optionLabel }) => {
    return (
        <>
            {
                question[optionLabel].some(opt => opt !== null) ?
                    <Autocomplete
                        disablePortal
                        id={`selectradio${(index + 1)}${(question.id)}`}
                        options={question[optionLabel]}
                        sx={{ width: 300 }}
                        renderInput={(params) => <TextField {...params} label="Seleccione una opcion" />}
                    />
                    :
                    <p style={{ fontStyle: 'italic', color: 'red' }}>
                        No hay opciones disponibles
                    </p>
            }
        </>
    )
}